export default "__VITE_ASSET__a012a3a6__"